module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/search_result_page/profile_image-2cc1fb4417e5c516fe873d379bcd5473.png";